import {
  EyeClosedIcon,
  EyeOpenIcon,
  StarFilledIcon,
  StarIcon,
} from "@radix-ui/react-icons";
import { Box, Flex, IconButton, Text } from "@radix-ui/themes";
import Animal from "react-animals";

interface TimelineGroupItemProps {
  content: number | string;
  color: string;
  isHidden: boolean;
  isSaved: boolean;
  onHide?: () => void;
  onSave?: () => void;
  canHide?: boolean;
  canSave?: boolean;
  animalName?: string;
  animalColor?: string;
  groupId?: string;
}

const TimelineGroupItem = ({
  content,
  color,
  isHidden = false,
  isSaved = false,
  onHide,
  onSave,
  canHide = false,
  canSave = false,
  animalName,
  animalColor,
  groupId,
}: TimelineGroupItemProps) => {
  const starIcon = isSaved ? (
    <StarFilledIcon width={16} height={16} />
  ) : (
    <StarIcon width={16} height={16} />
  );

  const eyeIcon = isHidden ? (
    <EyeClosedIcon width={16} height={16} />
  ) : (
    <EyeOpenIcon width={16} height={16} />
  );

  const hasAvatar = animalName && animalColor;
  const isSystemTime = groupId === "system-time";

  if (isSystemTime) {
    return <Box className="system-time-group"></Box>;
  }

  return (
    <Flex align="center" justify="between">
      {hasAvatar ? (
        <Flex align="center" justify="between" gap="2" className="w-full">
          <Text size="1" weight="regular" color="gray" highContrast>
            {content}
          </Text>

          <Animal name={animalName} color={animalColor} size="16px" />
        </Flex>
      ) : (
        <Flex align="center" gap="2">
          <Text size="1" weight="regular" color="gray" highContrast>
            {content}
          </Text>
        </Flex>
      )}

      <Flex align="center" ml="6" className="group-item-action-buttons">
        {canHide ? (
          <IconButton
            variant="ghost"
            color="gray"
            size="1"
            mr="3"
            onClick={() => onHide?.()}
          >
            {eyeIcon}
          </IconButton>
        ) : null}
        {canSave ? (
          <IconButton
            variant="ghost"
            color="gray"
            size="1"
            mr="2"
            onClick={() => onSave?.()}
          >
            {starIcon}
          </IconButton>
        ) : null}
        <Box
          width="8px"
          height="24px"
          style={{
            backgroundColor: color,
            borderBottom: "1px solid #eee",
          }}
        ></Box>
      </Flex>
    </Flex>
  );
};

export default TimelineGroupItem;
